/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __extends } from "tslib";
import { AVM1Object } from '../runtime/AVM1Object';
import { wrapAVM1NativeMembers } from './AVM1Utils';
import { release } from '@awayfl/swf-loader';
var AVM1Stage = /** @class */ (function (_super) {
    __extends(AVM1Stage, _super);
    function AVM1Stage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AVM1Stage.createAVM1Class = function (context) {
        var wrapped = new AVM1Stage(context);
        wrapAVM1NativeMembers(context, wrapped, AVM1Stage.prototype, ['align#', 'displayState#', 'fullScreenSourceRect#', 'height#',
            'scaleMode#', 'showMenu#', 'width#'], false);
        return wrapped;
    };
    AVM1Stage.bindStage = function (context, cls, avmStage, avm1Handler, htmlElement) {
        cls.avmStage = avmStage;
        cls.avm1Handler = avm1Handler;
        AVM1Stage.avmStage = avmStage;
    };
    AVM1Stage.prototype.getAlign = function () { return this.avmStage.align; };
    AVM1Stage.prototype.setAlign = function (value) { this.avmStage.align = value; };
    AVM1Stage.prototype.getDisplayState = function () {
        //release || console.log("not implemented AVM1Stage.getDisplayState")
        //return this._stage.displayState;
        return this.avmStage.displayState;
    };
    AVM1Stage.prototype.setDisplayState = function (value) {
        //release || console.log("not implemented AVM1Stage.setDisplayState")
        //this._stage.displayState = value;
        this.avmStage.displayState = value;
    };
    AVM1Stage.prototype.getFullScreenSourceRect = function () {
        release || console.log('not implemented AVM1Stage.getFullScreenSourceRect');
        //return this._stage.fullScreenSourceRect;
        return null;
    };
    AVM1Stage.prototype.setFullScreenSourceRect = function (value) {
        release || console.log('not implemented AVM1Stage.setFullScreenSourceRect');
        //this._stage.fullScreenSourceRect = value;
    };
    AVM1Stage.prototype.getHeight = function () { return this.avmStage.stageHeight; };
    AVM1Stage.prototype.getScaleMode = function () { return this.avmStage.scaleMode; };
    AVM1Stage.prototype.setScaleMode = function (value) { this.avmStage.scaleMode = value; };
    AVM1Stage.prototype.getShowMenu = function () {
        release || console.log('not implemented AVM1Stage.getShowMenu');
        //return this._stage.showDefaultContextMenu;
        return null;
    };
    AVM1Stage.prototype.setShowMenu = function (value) {
        release || console.log('not implemented AVM1Stage.setShowMenu');
        //this._stage.showDefaultContextMenu = value;
    };
    AVM1Stage.prototype.getWidth = function () { return this.avmStage.stageWidth; };
    return AVM1Stage;
}(AVM1Object));
export { AVM1Stage };
